import { gql } from '@apollo/client/core';

export const CONTACTED_MEMBERS_QUERY = gql`
  query contactedMembers($first: Int, $after: String, $searchByName: String) {
    viewer {
      ... on Parent {
        contactedMembers(first: $first, after: $after, searchByName: $searchByName) {
          pageInfo {
            hasNextPage
          }
          edges {
            cursor
            node {
              displayName
              photoUrl
              id
              lastContactAt
              hasBooked
            }
          }
        }
      }
    }
  }
`;

export const SITTER_QUERY = gql`
  query sitter($id: UUID!) {
    account(id: $id) {
      ... on Sitter {
        id
        displayName
        firstName
        photoUrl
        minPayRate
        maxPayRate
        reviews {
          starAggregate
          totalReviewCount
        }
      }
    }
  }
`;

export const SC_CARE_SESSION_QUERY = gql`
  query scCareSession($scCareSessionId: Int!) {
    corp {
      backupCare {
        scCareSession(id: $scCareSessionId) {
          bhReservationRequest {
            bhReservationRequestId
          }
          id
          careType
          start
          end
          location {
            details
            geoPoint {
              x
              y
            }
          }
          request {
            details
          }
          recipientCount
          individualCareRecipientDetails {
            startDateTime
            endDateTime
            firstName
            status
          }
        }
      }
    }
  }
`;

export const BH_RESERVATION_REQUESTS = gql`
  query bhReservationRequests {
    corp {
      backupCare {
        bhReservationRequests {
          reimbursement {
            amount
            currency
            symbol
          }
          scCareSessions {
            bookingState
            start
            end
            id
            request {
              id
              expiry
              identifiedSitters {
                sitter {
                  firstName
                  lastInitial
                  contactAvailable
                }
              }
              contract {
                id
                sitter {
                  firstName
                  lastInitial
                  contactAvailable
                }
              }
            }
          }
          bhReservationRequestId
        }
      }
    }
  }
`;

export const SC_CARE_SESSIONS_QUERY = gql`
  {
    corp {
      backupCare {
        bhReservationRequests {
          scCareSessions {
            id
            careType
            createdAt
            start
            bhReservationRequest {
              bhReservationRequestId
            }
          }
        }
      }
    }
  }
`;

export const PREPOPULATE_RESERVATION_QUERY = gql`
  {
    corp {
      backupCare {
        bhReservationRequests {
          expiresAt
          createdAt
          bhReservationRequestId
          scCareSessions {
            id
            careType
            start
            end
            individualCareRecipientDetails {
              dateOfBirth
              status
            }
            location {
              details
              geoPoint {
                x
                y
              }
            }
          }
        }
      }
    }
  }
`;
